import styled from "styled-components";

export const Container = styled.div`
    width: 100%;
	display: flex;
	background-color: #292926;
	backdrop-filter: blur(15px);
	border-radius: 15px;
	margin-bottom: 1rem;
	padding: 2rem 1rem 2rem 1rem;
	gap: 1rem;
    max-width: 728px;

 .emoji {
    display: flex;
	align-items: center;
	justify-content: center;
	font-size: 30pt;
	width: 20%;
 }

 .text {
    color: #ffffff;
	font-family: 'Poppins', sans-serif;
	font-weight: 600;
	font-size: 13pt;
	width: 70%;
 }
    
`